import { useState } from 'react';
import { Box, Popover } from '@mui/material';
import { EMOJIS } from '../config/paleta';

export function SeletorEmoji({ onSelecionar, children }) {
    const [ancora, setAncora] = useState(null);

    return (
        <>
            <Box component="span" onClick={(evento) => setAncora(evento.currentTarget)}>
                {children}
            </Box>

            <Popover
                open={!!ancora}
                anchorEl={ancora}
                onClose={() => setAncora(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Box sx={{ p: 1, display: 'grid', gridTemplateColumns: 'repeat(8, 36px)', gap: 0.5 }}>
                    {EMOJIS.map((emoji) => (
                        <Box
                            key={emoji}
                            component="button"
                            type="button"
                            onClick={() => {
                                onSelecionar(emoji);
                                setAncora(null);
                            }}
                            sx={{
                                width: 36,
                                height: 36,
                                fontSize: 20,
                                border: 0,
                                borderRadius: 1,
                                bgcolor: 'transparent',
                                cursor: 'pointer',
                                '&:hover': { bgcolor: 'action.hover' },
                            }}
                        >
                            {emoji}
                        </Box>
                    ))}
                </Box>
            </Popover>
        </>
    );
}